import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './CheckBox.less';
import Icon, { ICON_TYPE } from '../Icon/Icon';

export const CHECKBOX_LABEL_STYLE = {
    NORMAL: '',
    SUPPORTING: 'vx_text-legal'
};

export default class CheckBox extends Component {
    static propTypes = {
        alignLabelTop: PropTypes.bool, // Align label to the top of the checkbox (for multi-line labels)
        allowErrorPopout: PropTypes.bool,
        alignErrorLeft: PropTypes.bool, // Align the error with the checkbox instead of with the label
        description: PropTypes.node,
        disabled: PropTypes.bool,
        id: PropTypes.string.isRequired,
        label: PropTypes.node.isRequired,
        labelStyle: PropTypes.oneOf(Object.values(CHECKBOX_LABEL_STYLE)),
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        onClick: PropTypes.func,
        onFocus: PropTypes.func,
        readOnly: PropTypes.bool,
        required: PropTypes.bool,
        showErrorOnSubmitFail: PropTypes.bool,

        // Provided by Field HOC
        input: PropTypes.object.isRequired,
        meta: PropTypes.object.isRequired
    };

    static defaultProps = {
        alignLabelTop: false,
        allowErrorPopout: false,
        alignErrorLeft: false,
        disabled: false,
        labelStyle: CHECKBOX_LABEL_STYLE.SUPPORTING,
        readOnly: false,
        required: false,
        showErrorOnSubmitFail: false,
    };

    // workaround for meta.touched always false before submit
    // It's a bug https://github.com/erikras/redux-form/issues/3330
    onBlur = (e) => {
        this.touched = true;
        this.props.onBlur && this.props.onBlur(e);
    };

    render() {
        const {
            alignLabelTop,
            allowErrorPopout,
            alignErrorLeft,
            id,
            input,
            description,
            disabled,
            label,
            labelStyle,
            meta: {
                active,
                touched,
                error,
                submitFailed
            },
            onClick,
            onFocus,
            readOnly,
            required,
            showErrorOnSubmitFail
        } = this.props;
        const inputName = input.name || id;
        let hasError = !!((active || touched || this.touched) && error);
        hasError = showErrorOnSubmitFail ? hasError && submitFailed : hasError;
        const errorClass = hasError ? error.className : '';
        const wrapperClasses = [
            'CheckBox',
            'vx_checkbox',
            errorClass
        ];

        let errorInputAttributes = {};
        if (hasError) {
            errorInputAttributes = {
                'aria-describedby': 'cbError'
            };
        }

        return (
            <div className={wrapperClasses.join(' ')}>
                <input
                    {...input}
                    type="checkbox"
                    name={inputName}
                    id={id}
                    checked={input.value}
                    disabled={disabled}
                    onClick={onClick}
                    onFocus={onFocus}
                    onBlur={this.onBlur}
                    readOnly={readOnly}
                    required={required}
                    data-errormsg={error && (error.msg || '')}
                    data-errorshowmsg={hasError && allowErrorPopout}
                    data-haserror={hasError}
                    {...errorInputAttributes}
                />
                <label
                    htmlFor={id}
                    className={`Checkbox-label-wrapper label-for-${id}`}
                    data-automation-id={`checkbox-${id}`}
                >
                    <div className={`CheckBox-text-wrapper ${alignLabelTop ? 'label-top' : ''}`}>
                        <div className={`CheckBox-text CheckBox-text-for-${id} ${labelStyle}`}>{label}</div>
                        {description && <div className="CheckBox-desc vx_text-legal">{description}</div>}
                        {hasError && !alignErrorLeft && (
                            <div className="CheckBox-errorMsg vx_text-body-sm">
                                <div className="CheckBox-errorMsg-left">
                                    <Icon type={ICON_TYPE.CRITICAL} className="CheckBox-errorIcon" />
                                </div>
                                <div id="cbError" className="CheckBox-errorMsg-right">
                                    {error.msg}
                                </div>
                            </div>
                        )}
                    </div>
                </label>
                {hasError && alignErrorLeft && (
                    <div className="CheckBox-errorMsg CheckBox-errorMsg-align-left vx_text-body-sm">
                        <div className="CheckBox-errorMsg-left">
                            <Icon type={ICON_TYPE.CRITICAL} className="CheckBox-errorIcon" />
                        </div>
                        <div id="cbError" className="CheckBox-errorMsg-right">
                            {error.msg}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
